import React from 'react'
import styles from './card.module.scss'

function Card({ image, children, link, filterByPrice, buttonSeeMore }) {
  return (
    <div className={styles.card}>
      <a href={link + (filterByPrice.value || '')} title={children} target="_blank" rel="noopener noreferrer">
        <picture>
          <img
            src={require(`../../img/${process.env.REACT_APP_BRAND}/card/${image}`)}
            className={styles.img}
            alt={children}
          />
        </picture>
        <div className={styles.card__title}>
          <small className={styles.card__name + ` card-name-${process.env.REACT_APP_BRAND}`}>{children}</small>
        </div>

        {(buttonSeeMore &&
          <div className={styles.card__more}><p>{buttonSeeMore}</p></div>
        )}
      </a>
    </div>
  )
}

export { Card }
